import { api, getToken, API } from "./lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
export function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
}
export function pushPermission() {
  return "Notification" in window ? Notification.permission : "unsupported";
}

export async function enablePush() {
  if (!pushSupported()) {
    if (isIOS() && !isStandalone()) {
      throw new Error("Su iPhone/iPad installa prima l'app: tocca Condividi e poi 'Aggiungi alla schermata Home', apri l'app da lì e riprova.");
    }
    throw new Error("Questo browser non supporta le notifiche push.");
  }
  // Una volta negato, il browser NON richiede più il permesso: va sbloccato a mano.
  if (Notification.permission === "denied") {
    throw new Error("Notifiche BLOCCATE nel browser. Sbloccale dal lucchetto vicino all'indirizzo del sito (Notifiche → Consenti), poi riprova.");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permesso negato. Quando appare la richiesta del browser scegli 'Consenti'. Se non appare più, sbloccale dal lucchetto vicino all'indirizzo del sito.");
  }

  const registration = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { publicKey } = await api("/push/vapid-public-key", { auth: false });
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  const json = subscription.toJSON();
  await fetch(`${API}/push/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify({ endpoint: json.endpoint, keys: json.keys, user_agent: navigator.userAgent }),
  });
  return true;
}

export async function testPush() {
  return api("/push/test", { method: "POST" });
}
